import { Box, Container, Paper, } from "@mui/material";
import { useEffect, useState } from "react";
import { fetchFromApi } from "../helpers/fetchFromApi";
import { el } from "date-fns/locale";
import { sortFixturesCanonical } from "../helpers/fixtureOrder";

export function BContainer({ uri, text }) {
  const [startDate, setStartDate] = useState(
    new Date(sessionStorage.getItem("startDate") ?? new Date())
  );

  const [exportResponse, setExportResponse] = useState("Loading...");
  const [leagues, setLeagues] = useState([]);
  const [fixtures, setFixtures] = useState([]);

  const [csv, setCsv] = useState("");

  async function getFixtures() {
    var request;
    try {
      request = await fetchFromApi(
        `fetch-data-v3/fixtures/between/${startDate.toISOString().split("T")[0]}/${startDate.toISOString().split("T")[0]}?include=scores;state;participants`
      );
    } catch (e) {
    }
    if (request.ok) {
      const response = await request.json();
      setFixtures(sortFixturesCanonical(response.data));
      console.log("Fixtures", response.data);
      return response.data;
    } else {
      console.error("Error fetching fixtures:", request.statusText);
      return [];
    }
  }
  async function getLeages() {
    const request = await fetchFromApi("fetch-data-v3/leagues?include=country");
    if (request.ok) {
      const response = await request.json();
      console.log("Leagues", response.data);
      setLeagues(response.data);
    } else {
      console.error("Error fetching leagues:", request.statusText);
      setLeagues([]);
    }
  }

  useEffect(() => {
    console.log("URI", fixtures);

    getFixtures();
    getLeages();
  }, [uri]);

  useEffect(() => {
    if (fixtures.length > 0) {
      const rows = fixtures.map((fixture) => {
        const { name, country, user_id } = leagues.find((l) => l.id === fixture.league_id) ?? {};

        // Add German hour difference (UTC+2) to UTC date
        // Detect UTC offset from fixture.starting_at (e.g. "2024-06-07T18:00:00+02:00" or "2024-06-07T18:00:00+01:00")
        let offsetMatch = fixture.starting_at.match(/([+-]\d{2}):?(\d{2})?$/);
        let offsetHours = 2; // default to UTC+2 if not found
        if (offsetMatch) {
          offsetHours = parseInt(offsetMatch[1], 10);
        }
        const germanDate = new Date(new Date(fixture.starting_at).getTime() + offsetHours * 60 * 60 * 1000);

        return {
          ...fixture,
          details: {
            date: germanDate,
            id: fixture.id,
          },
          league: { name, country },
          user: { id: "paule@paule-wetten.de" },
          localTeam: {
            ...fixture.participants?.find(p => p.meta.location === "home"),
            custom_name: fixture.localTeam?.data?.name
          },
          visitorTeam: {
            ...fixture.participants?.find(p => p.meta.location === "away"),
            custom_name: fixture.visitorTeam?.data?.name
          },
          ...fixture.probs,
        };
      });
      console.log("Rows", rows);

      const csvData = [
        "id,league",
        ...rows.map((row) => {
          const localTeam = row.localTeam?.data?.name || row.localTeam?.custom_name || "Unknown Home Team";
          const visitorTeam = row.visitorTeam?.data?.name || row.visitorTeam?.custom_name || "Unknown Away Team";
          const date = row.details.date.toLocaleDateString("de-DE", {
            weekday: "short",
            day: "numeric",
            month: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
          const leagueName = row.league?.name || "Unknown League";
          const countryName = row.league?.country?.data?.name || "Unknown Country";
          return `${row.details.id},"${leagueName} (${countryName})","${localTeam} vs ${visitorTeam}","${date}",${row.probability_home},${row.probability_draw},${row.probability_away}`;
        }),
      ].join("\n");
      
      setCsv(csvData);
    }
  }, [fixtures]);

  return <Container maxWidth="xl" style={{ height: "100%" }}>
    <Box
      sx={{
        display: "flex",
        height: "75vh",
        "& .row--expanded": {
          bgcolor: (theme) => "rgb(255,181,99,0.2)",
        },
      }}
      component={Paper}
    >
      <div style={{ flexGrow: 1, alignContent: "center", overflowY: "scroll" }}>
        <pre>
          {csv}
        </pre>
      </div>
    </Box>
  </Container>
}
